import moment from "moment";
import React from "react";
import { Table } from "react-bootstrap";
import { Constants } from "../../libs/Constants";
import { formatCurrency } from "../../libs/utils";

const LoanTransactions = ({ transactions }) => {
  return (
    <>
      <div className="p-4">
        <div className="pull-right fw-bold">
          Balance: {formatCurrency(transactions?.balance)}
        </div>
      </div>
      <div>
        <Table borderless className="font-size-4" responsive size="sm">
          <thead className="text-purplel">
            <tr key="headings">
              <th className="p-1">Date</th>
              <th className="p-1">Amount</th>
              <th className="p-1">Fee</th>
              <th className="p-1">Payment Method</th>
              <th className="p-1">Status</th>
              <th className="p-1 pull-right">Total Amount</th>
            </tr>
          </thead>
          <tbody>
            {!transactions ||
              (transactions.results?.length === 0 && (
                <tr key="notxn">
                  <td className="ps-1">No transactions</td>
                </tr>
              ))}
            {transactions?.results?.map((tx, index) => {
              return (
                <tr key={index}>
                  <td className="p-1">
                    {moment.utc(tx.created).format(Constants.DATEFORMAT.MMDDYYYY)}
                  </td>
                  <td className={`p-1`}>{formatCurrency(tx.amount.value)}</td>
                  <td className={`p-1`}>
                    {tx.fee ? formatCurrency(tx.fee) : ""}
                  </td>
                  <td className={`p-1 text-capitalize`}>
                    {tx.paymentMode ? tx.paymentMode : ""}
                  </td>
                  <td className={`p-1 text-capitalize`}>
                    {tx.status ? tx.status : ""}
                  </td>
                  <td
                    className={`p-1 pull-right ${
                      tx.amount.value < 0 ? "text-red" : "text-green"
                      }`}
                  >
                    {tx?.status === Constants.DWOLLA_TRANSACTION_STATUS.PROCESSED
                      ? formatCurrency(tx.amount.value + (tx.fee || 0))
                      : "-"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default LoanTransactions;
